var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { footerColumns } from './../utils';
var FooterRow = {
  name: 'FooterRow',
  props: {
    columns: Array
  },
  methods: {
    columnStyles: function columnStyles(column) {
      return column.left !== undefined ? {
        position: 'sticky',
        left: column.left + 'px',
        right: column.right + 'px',
        zIndex: 1,
        background: '#f6f6f6',
        borderRightWidth: column.rightBorder ? '1px' : undefined
      } : undefined;
    }
  },
  // @ts-ignore
  render: function render(h) {
    var _this = this;

    var renderCell = function renderCell(column, index) {
      var footerCellRendering = null;

      if (column.footerCell) {
        var columnProps = {
          field: column.field,
          colSpan: column.colSpan !== 1 ? column.colSpan : undefined,
          defaultStyle: _this.columnStyles(column)
        };

        var events = __assign({}, column.footerCell.listeners);

        if (column.footerCell.type === 'slot') {
          footerCellRendering = column.footerCell.render({
            props: columnProps,
            listeners: events,
            methods: events
          })[0];
        } else if (column.footerCell.type === 'renderFunction') {
          footerCellRendering = column.footerCell.render(h, footerCellRendering, columnProps, events);
        } else {
          footerCellRendering = h(column.footerCell.render, {
            props: columnProps,
            on: events
          });
        }
      }

      return h("td", {
        key: index,
        attrs: {
          field: column.field,
          colSpan: column.colSpan !== 1 ? column.colSpan : undefined
        },
        style: _this.columnStyles(column),
        "class": column.footerClassName
      }, [footerCellRendering]);
    };

    return h("tr", [footerColumns(this.$props.columns).map(renderCell)]);
  }
};
export { FooterRow };